import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { HostConfigService } from '@/common/host-config/host-config.service';
import { NewTopSearchModule } from '@/new-top-search/new-top-search.module';

@Component({
	selector: 'app-hero',
	standalone: true,
	imports: [CommonModule, NgOptimizedImage, NewTopSearchModule],
	templateUrl: './hero.component.html',
})
export class HeroComponent {
	readonly hostConfig = inject(HostConfigService);

	/** Root-relative paths (encoded) — do not use `optimizedImage` pipe; it targets CDN API, not local `/assets/`. */
	readonly heroBannerMobileSrc = encodeURI('/assets/baner_mobile.png');
	readonly heroBannerDesktopSrc = encodeURI('/assets/baner_desktop.png');

	readonly isOfferList = input.required<boolean>();
}
